export default class {

    onCreate() {
        this.state = {
            username: "",
            passwd: "",
            hint: "",
            msg: "",
            isUserNameInvalid: false,
            isPasswdInvalid: false,
            isHintInvalid: false
        }
    }

    changeUserName({ value }) {
        if (!value || value.length < 6) {
            this.state.isUserNameInvalid = true;
            return
        }

        this.state.username = value;
        this.state.isUserNameInvalid = false;
    }

    changePasswd({ value }) {
        if (!value || value.length < 6) {
            this.state.isPasswdInvalid = true;
            return
        }

        this.state.passwd = value;
        this.state.isPasswdInvalid = false;
    }
    changeHint({ value }) {
        if (!value || value.length < 6) {
            this.state.isHintInvalid = true;
            return
        }

        this.state.hint = value;
    }

    handleSendCodeEvent(event) {
        const myInit = {
            method: "POST",
            headers: {
                Accept: "application/json",
                ContentType: "application/json; charset=UTF-8",
            },
            mode: "cors",
            cache: "default",
            body: JSON.stringify({ username: this.state.username }),
        };

        const myRequest = new Request("/search/login/generateCode", myInit);
        fetch(myRequest)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                // return response.json();
            });
    }

    handleLoginEvent(event) {
        if (this.state.isUserNameInvalid || this.state.isPasswdInvalid) {
            this.state.msg = "用户名、密码 最小长度为6";
            return
        }

        const that = this;
        that.state.msg = "";

        const myInit = {
            method: "POST",
            headers: {
                Accept: "application/json",
                ContentType: "application/json; charset=UTF-8",
            },
            mode: "cors",
            cache: "default",
            body: JSON.stringify({ username: that.state.username, passwd: that.state.passwd }),
        };

        const myRequest = new Request("/login", myInit);
        fetch(myRequest)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                that.state.msg = data.msg;

                if (data.result) {
                    setTimeout(function () {
                        window.location.href = "/";
                    }, 2100);
                }
            });
    }

    handleRegEvent(event) {
        if (this.state.isUserNameInvalid || this.state.isPasswdInvalid || this.state.isHintInvalid) {
            this.state.msg = "用户名、密码、密语 最小长度为6";
            return
        }

        const that = this;
        that.state.msg = "";

        const myInit = {
            method: "POST",
            headers: {
                Accept: "application/json",
                ContentType: "application/json; charset=UTF-8",
            },
            mode: "cors",
            cache: "default",
            body: JSON.stringify({ username: that.state.username, passwd: that.state.passwd, hint: that.state.hint }),
        };

        const myRequest = new Request("/register", myInit);
        fetch(myRequest)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                that.state.msg = data.msg;

                if (data.result) {
                    setTimeout(function () {
                        window.location.href = "/profile";
                    }, 2100);
                }
            });
    }

    handleFindPasswdEvent(event) {
        if (this.state.isUserNameInvalid || this.state.isPasswdInvalid || this.state.isHintInvalid) {
            this.state.msg = "用户名、密码、密语 最小长度为6";
            return
        }

        const that = this;
        that.state.msg = "";

        const myInit = {
            method: "POST",
            headers: {
                Accept: "application/json",
                ContentType: "application/json; charset=UTF-8",
            },
            mode: "cors",
            cache: "default",
            body: JSON.stringify({ username: that.state.username, hint: that.state.hint, passwd: that.state.passwd }),
        };

        const myRequest = new Request("/findPasswd", myInit);
        fetch(myRequest)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                return response.json();
            })
            .then((data) => {
                that.state.msg = data.msg;

                if (data.result) {
                    setTimeout(function () {
                        window.location.href = "/";
                    }, 2100);
                }

            });
    }
}

